import Box from "@mui/material/Box";
import {MetadataRow} from "./MetadataRow";
import Typography from "@mui/material/Typography";

/**
 * Component that renders a list of reference types.
 * @param {Object} t - Translation object.
 * @param {Object[]} referenceTypes - Array of reference types.
 * @returns {React.JSX.Element} A box containing a list of reference types,
 * each consisting of a type, description and url.
 */
export const ReferenceTypes = ({t, referenceTypes}) => {
    return <Box>
        {referenceTypes.map(r => {
            return <Box key={r.refGuid} sx={{display: 'flex', flexDirection: 'column', marginBottom: '8px'}}>
                <MetadataRow label={t('lblReferenceType', 'Type')}>
                    <Typography variant="caption">{r.refType.title}</Typography>
                </MetadataRow>
                {r.refDescription &&
                    <MetadataRow label={t('lblReferenceTypeDescription', 'Beskrivelse')}>
                        <Typography variant="caption">{r.refDescription}</Typography>
                    </MetadataRow>
                }
                {r.refUrl &&
                    <MetadataRow label={t('lblReferenceTypeUrl', 'URL')}>
                        <Typography variant="caption">{r.refUrl}</Typography>
                    </MetadataRow>
                }
            </Box>;
        })}
    </Box>;
};